// Single source of truth for the Sentry release identifier.
//
// Source maps uploaded by `@sentry/nextjs` during the build are tagged with a
// release name. For Sentry to apply those maps to a runtime event, the
// `release` passed to `Sentry.init` MUST match the one used at upload time.
//
// On Vercel we use `VERCEL_GIT_COMMIT_SHA` for both. The build picks it up via
// `withSentryConfig({ release: { name } })` in `next.config.ts`, and the
// runtime picks it up here.
//
// Notes:
// - Only `NEXT_PUBLIC_*` env vars are inlined into the client bundle, so
//   `next.config.ts` promotes `VERCEL_GIT_COMMIT_SHA` to
//   `NEXT_PUBLIC_SENTRY_RELEASE` for the browser to read.
// - `SENTRY_RELEASE` is honored as an explicit override (e.g. local prod
//   builds, Docker images that aren't on Vercel).
// - Returns `undefined` outside CI/Vercel; `Sentry.init` then falls back to
//   its default release detection (or no release, which is fine in dev).
export const SENTRY_RELEASE: string | undefined =
  process.env.NEXT_PUBLIC_SENTRY_RELEASE ||
  process.env.SENTRY_RELEASE ||
  process.env.VERCEL_GIT_COMMIT_SHA ||
  undefined;
